import { LotInterface } from "@/types/LotInterface";
import { Business } from "@/types/BusinessInterface";
import { EstateInterface } from "@/types/EstateInterface";

export const isLotOwner = (
  lot: LotInterface | null,
  business: Business | null,
  estate?: EstateInterface | null
): boolean => {
  if (!lot) return true;

  if (!business) return true;

  if (!lot?.ownershipId) return true;

  const ownershipBusinessId =
    typeof lot.ownershipId === "object" ? lot.ownershipId._id : lot.ownershipId;

  if (!ownershipBusinessId) return true;

  return business._id === ownershipBusinessId;
};
